import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Header from './Header';
import Table from './Table';
import Pagination from './Pagination';

export default inject('root')(
  observer(({ root }) => {
    const { billingCodes, loadBillingCodes, loading, pagination } = root.billingCodes;

    useEffect(() => {
      loadBillingCodes();
    }, []);

    return (
      <>
        <Header />
        <Table
          loading={loading}
          billingCodes={billingCodes}
        />
         <Pagination pagination={pagination} />
      </>
    );
  })
)
